import {
  AccordionSummary,
  Box,
  Button,
  Chip,
  IconButton,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { useSearchParams } from "react-router-dom";
import Accordion from "@mui/material/Accordion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AccordionDetails from "@mui/material/AccordionDetails";
import { tests } from "../../util/consts";

const SpecialTests = ({ type, onSpecialTestsChange }) => {
  const [selectedTests, setSelectedTests] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const testsParam = searchParams.get("tests");
    if (testsParam) {
      setSelectedTests(JSON.parse(testsParam));
    }
  }, [searchParams]);

  useEffect(() => {
    if (type === "Accordion") {
      onSpecialTestsChange(selectedTests);
    }
  }, [selectedTests]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "special-tests" : undefined;

  useEffect(() => {
    if (open) {
      document.documentElement.style.overflow = "hidden";
      document.documentElement.style.paddingRight = "17px";
    } else {
      document.documentElement.style.overflow = "";
      document.documentElement.style.paddingRight = "";
    }
  }, [open]);

  const handleTestChange = (event) => {
    const { name, checked } = event.target;
    if (checked) {
      setSelectedTests((prev) => [...prev, name]);
    } else {
      setSelectedTests((prev) => prev.filter((test) => test !== name));
    }
  };

  const handleTestsClear = () => {
    setSelectedTests([]);
  };

  const handleApplyClick = () => {
    setSearchParams({
      ...Object.fromEntries(searchParams),
      tests: JSON.stringify(selectedTests),
    });

    handleClose();
  };

  const checkboxes = tests.map((test) => (
    <FormControlLabel
      key={test.name}
      control={
        <Checkbox
          name={test.name}
          checked={selectedTests.includes(test.name)}
          onChange={handleTestChange}
        />
      }
      label={test.label}
    />
  ));

  const formControl = (
    <FormControl component="fieldset" variant="standard">
      <FormGroup>{checkboxes}</FormGroup>
    </FormControl>
  );

  if (type === "Accordion") {
    return (
      <Accordion sx={{ backgroundColor: "#f7f7f7" }}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="special-test-content"
          id="special-test-header"
        >
          <Typography>Special Tests</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ textAlign: "center" }}>{formControl}</Box>
        </AccordionDetails>
      </Accordion>
    );
  }

  return (
    <>
      <Chip
        label="Special Tests"
        variant="outlined"
        color="white"
        onClick={handleClick}
        sx={{ width: "100%", fontSize: { xs: "0.69rem", sm: "0.8125rem" } }}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        sx={{ marginTop: "-32px", borderRadius: "25px" }}
        slotProps={{ paper: { sx: { borderRadius: "16px" } } }}
      >
        <Box sx={{ borderRadius: "25px", padding: "0", width: "195px" }}>
          <Stack spacing={2}>
            <Chip
              label="Special Tests"
              variant="outlined"
              color="white"
              // onClick={handleClick}
              sx={{
                width: "100%",
                fontSize: { xs: "0.69rem", sm: "0.8125rem" },
                backgroundColor: "#0B3C65",
              }}
            />
            {/*<Box*/}
            {/*  sx={{*/}
            {/*    display: "flex",*/}
            {/*    justifyContent: "space-between",*/}
            {/*    alignItems: "center",*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <Typography variant="button" display="block">*/}
            {/*    Special Tests*/}
            {/*  </Typography>*/}

            {/*  <IconButton aria-label="clear" onClick={handleClose}>*/}
            {/*    <CloseIcon />*/}
            {/*  </IconButton>*/}
            {/*</Box>*/}
            <Box sx={{ padding: "0 18px 18px 18px" }}>
              <Box
                sx={{
                  height: 200,
                  overflow: "auto",
                  display: "flex",
                  flexDirection: "column",
                }}
                className="scroll--simple"
              >
                {formControl}
              </Box>
              <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Button size="small" variant="text" onClick={handleTestsClear}>
                  clear
                </Button>
                <Button
                  color="yellow"
                  variant="contained"
                  sx={{
                    borderRadius: "25px",
                    marginTop: "2px",
                    fontWeight: 600,
                  }}
                  onClick={handleApplyClick}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Stack>
        </Box>
      </Popover>
    </>
  );
};

export default SpecialTests;
